import { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../context/Context";
import Select2 from "../select2/Select2";
import { MqttContext } from "../../context/MQTTContext";

const DefineChartModal = ({
  button,
  device,
  chartCount,
  hasStatus,
  hasCycle,
  hasQuantity,
  hasDataAddress,
  hasFunctionCode,
  hasSlaveAddress,
  hasSubmitKey,
  hasSendOnChange,
}) => {
  const { setDefineChartModal, update, setEquipmentButtons, equipmentButtons } =
    useContext(Context);
  const { clients } = useContext(MqttContext);

  const [selectedCycle, setSelectedCycle] = useState(1);
  const [cycleNum, setCycleNum] = useState(1);
  const [status, setStatus] = useState(0);
  const [sendOnChange, setSendOnChange] = useState(0);
  const [selectedChart, setSelectedChart] = useState(null);
  const [chartsInfo, setChartsInfo] = useState([]);
  const [changeState, setChangeState] = useState(null);
  const [hasError, setHasError] = useState({
    type: null,
  });

  const modalName = useRef(null);
  const closeButton = useRef(null);
  const chartsInfoRef = useRef([]);

  useEffect(() => {
    chartsInfoRef.current = chartsInfo;
  }, [chartsInfo]);

  useEffect(() => {
    setDefineChartModal(modalName);
  }, []);

  useEffect(() => {
    if (!device || !clients[device.id]) return;

    const client = clients[device.id];

    if (client._chartsListener) {
      client.off("message", client._chartsListener);
      client._chartsListener = null;
    }

    const messageListener = (topic, message) => {
      console.log(message)
      const endOfTwoCharToken =
        String.fromCharCode(message[0]) + String.fromCharCode(message[1]);

      if (
        device.internet_token.slice(-2) === endOfTwoCharToken &&
        message[2] == 17
      ) {
        const chartSize = device.type == 16 ? 11 : 3;
        const chartCount = (message.byteLength - 3) / chartSize;
        const data = message.slice(3);

        const charts = [];
        for (let i = 0; i < chartCount; i++) {
          charts.push(data.slice(i * chartSize, (i + 1) * chartSize));
        }

        setChartsInfo(charts);
        setChangeState(null);
      }
    };

    client._chartsListener = messageListener;
    client.on("message", messageListener);

    return () => {
      if (client._chartsListener === messageListener) {
        client.off("message", messageListener);
        client._chartsListener = null;
      }
    };
  }, [device]);

  useEffect(() => {
    if (!device || !clients[device.id]) return;

    setHasError(null);
    setChartsInfo([]);

    const client = clients[device.id];

    if (device.type == 16) {
      let buffer = new ArrayBuffer(13);
      let asciiCode = new Uint8Array(buffer);
      asciiCode.fill(0);
      asciiCode[0] = 17;

      const combinedMessage = concatenateStringAndBuffer(
        device.internet_token,
        asciiCode,
      );

      client.publish(device.serial + "/sys", combinedMessage);
    } else {
      let buffer = new ArrayBuffer(5);
      let asciiCode = new Uint8Array(buffer);
      asciiCode.fill(0);
      asciiCode[0] = 17;

      const combinedMessage = concatenateStringAndBuffer(
        device.internet_token,
        asciiCode,
      );

      client.publish(device.serial + "/sys", combinedMessage);
    }
  }, [update, device]);

  useEffect(() => {
    if (
      !device ||
      !(changeState || changeState === 0) ||
      hasSubmitKey ||
      !clients[device.id]
    )
      return;

    const client = clients[device.id];
    const chartInfo = chartsInfo[changeState];
    if (!chartInfo) return;

    if (device.type == 16) {
      let buffer = new ArrayBuffer(13);
      let asciiCode = new Uint8Array(buffer);

      asciiCode[0] = 17;
      asciiCode[1] = selectedChart + 1;
      asciiCode[2] = chartInfo[0];
      asciiCode[3] = chartInfo[1];
      asciiCode[4] = chartInfo[2];
      asciiCode[5] = chartInfo[3];
      asciiCode[6] = chartInfo[4];
      asciiCode[7] = chartInfo[5];

      let crc16 = calculateCRC16Modbus([
        asciiCode[2],
        asciiCode[3],
        asciiCode[4],
        asciiCode[5],
        asciiCode[6],
        asciiCode[7],
      ]);

      asciiCode[8] = crc16[0];
      asciiCode[9] = crc16[1];
      asciiCode[10] = Number(chartInfo[8]);
      asciiCode[11] = chartInfo[9];
      asciiCode[12] = chartInfo[10];

      const combinedMessage = concatenateStringAndBuffer(
        device.internet_token,
        asciiCode,
      );

      client.publish(device.serial + "/sys", combinedMessage);
    } else {
      let buffer = new ArrayBuffer(5);
      let asciiCode = new Uint8Array(buffer);

      asciiCode[0] = 17;
      asciiCode[1] = selectedChart + 1;
      asciiCode[2] = Number(chartInfo[0]);
      asciiCode[3] = chartInfo[1];
      asciiCode[4] = chartInfo[2];

      const combinedMessage = concatenateStringAndBuffer(
        device.internet_token,
        asciiCode,
      );

      client.publish(device.serial + "/sys", combinedMessage);
    }
  }, [changeState]);

  // useEffect(() => {
  //   setHasError(null);
  //   setChartsInfo([]);
  //   if (device && device.type == 16) {
  //     if (device.is_bus == 1 && clients[device?.bridge_device?.id]) {
  //     } else if (
  //       device.id &&
  //       device.username &&
  //       device.password &&
  //       clients[device.id]
  //     ) {
  //       const client = clients[device.id];

  //       // remove previous listener if exists
  //       if (client._chartsListener) {
  //         client.off("message", client._chartsListener);
  //         client._chartsListener = null;
  //       }
  //       const messageListener = (topic, message) => {
  //         const endOfTwoCharToken =
  //           String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
  //         if (
  //           device.internet_token.slice(-2) === endOfTwoCharToken &&
  //           message[2] == 17
  //         ) {
  //           const charts = [];
  //           const chartSize = 11;
  //           const chartCount = (message.byteLength - 3) / chartSize;
  //           const data = message.slice(3);
  //           for (let i = 0; i < chartCount; i++) {
  //             const chartData = data.slice(i * chartSize, (i + 1) * chartSize);
  //             charts.push(chartData);
  //           }
  //           setChartsInfo(charts);

  //           client.off("message", messageListener);
  //           client._chartsListener = null;
  //         }
  //       };

  //       // clients[device.id].removeAllListeners("message");
  //       // clients[device.id].on("message", messageListener);
  //       client._chartsListener = messageListener;
  //       client.on("message", messageListener);

  //       let buffer = new ArrayBuffer(13);
  //       let asciiCode = new Uint8Array(buffer);
  //       asciiCode[0] = 17;
  //       asciiCode[1] = 0;
  //       asciiCode[2] = 0;
  //       asciiCode[3] = 0;
  //       asciiCode[4] = 0;
  //       asciiCode[5] = 0;
  //       asciiCode[6] = 0;
  //       asciiCode[7] = 0;
  //       asciiCode[8] = 0;
  //       asciiCode[9] = 0;
  //       asciiCode[10] = 0;
  //       asciiCode[11] = 0;
  //       asciiCode[12] = 0;

  //       let message = device.internet_token;

  //       // ترکیب رشته و بافر
  //       let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

  //       clients[device.id].publish(device.serial + "/sys", combinedMessage);
  //       return () => {
  //         if (client._chartsListener) {
  //           client.off("message", client._chartsListener);
  //           client._chartsListener = null;
  //         }
  //       };
  //     }
  //   } else if (device) {
  //     if (device.is_bus == 1 && clients[device?.bridge_device?.id]) {
  //     } else if (
  //       device.id &&
  //       device.username &&
  //       device.password &&
  //       clients[device.id]
  //     ) {
  //       const client = clients[device.id];

  //       // remove previous listener if exists
  //       if (client._chartsListener) {
  //         client.off("message", client._chartsListener);
  //         client._chartsListener = null;
  //       }

  //       const messageListener = (topic, message) => {
  //         const endOfTwoCharToken =
  //           String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
  //         if (
  //           device.internet_token.slice(-2) === endOfTwoCharToken &&
  //           message[2] == 17
  //         ) {
  //           const charts = [];
  //           const chartSize = 3;
  //           const chartCount = (message.byteLength - 3) / chartSize;
  //           const data = message.slice(3);
  //           for (let i = 0; i < chartCount; i++) {
  //             const chartData = data.slice(i * chartSize, (i + 1) * chartSize);
  //             charts.push(chartData);
  //           }
  //           setChartsInfo(charts);

  //           client.off("message", messageListener);
  //           client._chartsListener = null;
  //         }
  //       };

  //       // clients[device.id].removeAllListeners("message");
  //       // clients[device.id].on("message", messageListener);
  //       client._chartsListener = messageListener;
  //       client.on("message", messageListener);

  //       let buffer = new ArrayBuffer(5);
  //       let asciiCode = new Uint8Array(buffer);
  //       asciiCode[0] = 17;
  //       asciiCode[1] = 0;
  //       asciiCode[2] = 0;
  //       asciiCode[3] = 0;
  //       asciiCode[4] = 0;

  //       let message = device.internet_token;

  //       // ترکیب رشته و بافر
  //       let combinedMessage = concatenateStringAndBuffer(message, asciiCode);

  //       clients[device.id].publish(device.serial + "/sys", combinedMessage);

  //       return () => {
  //         if (client._chartsListener === messageListener) {
  //           client.off("message", client._chartsListener);
  //           client._chartsListener = null;
  //         }
  //       };
  //     }
  //   }
  // }, [update, device]);

  useEffect(() => {
    if (hasError && hasError.type) {
      closeButton.current.click();
    }
  }, [hasError]);

  // useEffect(() => {
  //   if (
  //     device &&
  //     (changeState || changeState == 0) &&
  //     !hasSubmitKey &&
  //     device.type == 16
  //   ) {
  //     let chartInfo = chartsInfo[changeState];
  //     if (device.is_bus == 1 && clients[device?.bridge_device?.id]) {
  //     } else if (
  //       device.id &&
  //       device.username &&
  //       device.password &&
  //       clients[device.id]
  //     ) {
  //       const client = clients[device.id];
  //       // remove previous listener if exists
  //       if (client._chartsListener) {
  //         client.off("message", client._chartsListener);
  //         client._chartsListener = null;
  //       }
  //       const messageListener = (topic, message) => {
  //         const endOfTwoCharToken =
  //           String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
  //         if (
  //           device.internet_token.slice(-2) === endOfTwoCharToken &&
  //           message[2] == 17
  //         ) {
  //           // const charts = [];
  //           // const chartSize = 11; // تعداد المان‌های هر نمودار
  //           // const chartCount = (message.byteLength - 3) / chartSize;
  //           // const data = message.slice(4);
  //           // for (let i = 0; i < chartCount; i++) {
  //           //   const chartData = data.slice(i * chartSize, (i + 1) * chartSize);
  //           //   charts.push(chartData);
  //           // }
  //           // // setChartsInfo(charts);
  //           // closeButton.current.click();
  //           setChangeState(null);

  //           client.off("message", messageListener);
  //           client._chartsListener = null;
  //         }
  //       };

  //       client._chartsListener = messageListener;
  //       client.on("message", messageListener);

  //       let buffer = new ArrayBuffer(13);
  //       let asciiCode = new Uint8Array(buffer);
  //       asciiCode[0] = 17;
  //       asciiCode[1] = selectedChart + 1;
  //       asciiCode[2] = chartInfo[0];
  //       asciiCode[3] = chartInfo[1];
  //       asciiCode[4] = chartInfo[2];
  //       asciiCode[5] = chartInfo[3];
  //       asciiCode[6] = chartInfo[4];
  //       asciiCode[7] = chartInfo[5];
  //       let crc16 = calculateCRC16Modbus([
  //         asciiCode[2],
  //         asciiCode[3],
  //         asciiCode[4],
  //         asciiCode[5],
  //         asciiCode[5],
  //         asciiCode[7],
  //       ]);
  //       asciiCode[8] = crc16[0];
  //       asciiCode[9] = crc16[1];
  //       asciiCode[10] = Number(chartInfo[8]);
  //       asciiCode[11] = chartInfo[9];
  //       asciiCode[12] = chartInfo[10];

  //       let message = device.internet_token;

  //       // ترکیب رشته و بافر
  //       let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
  //       clients[device.id].publish(device.serial + "/sys", combinedMessage);

  //       return () => {
  //         if (client._chartsListener) {
  //           client.off("message", client._chartsListener);
  //           client._chartsListener = null;
  //         }
  //       };
  //     }
  //   } else if (device && (changeState || changeState == 0) && !hasSubmitKey) {
  //     let chartInfo = chartsInfo[changeState];
  //     if (device.is_bus == 1 && clients[device?.bridge_device?.id]) {
  //     } else if (
  //       device.id &&
  //       device.username &&
  //       device.password &&
  //       clients[device.id]
  //     ) {
  //       const client = clients[device.id];
  //       // remove previous listener if exists
  //       if (client._chartsListener) {
  //         client.off("message", client._chartsListener);
  //         client._chartsListener = null;
  //       }
  //       const messageListener = (topic, message) => {
  //         const endOfTwoCharToken =
  //           String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
  //         if (
  //           device.internet_token.slice(-2) === endOfTwoCharToken &&
  //           message[2] == 17
  //         ) {
  //           // const charts = [];
  //           // const chartSize = 11; // تعداد المان‌های هر نمودار
  //           // const chartCount = (message.byteLength - 3) / chartSize;
  //           // const data = message.slice(4);
  //           // for (let i = 0; i < chartCount; i++) {
  //           //   const chartData = data.slice(i * chartSize, (i + 1) * chartSize);
  //           //   charts.push(chartData);
  //           // }
  //           // // setChartsInfo(charts);
  //           // closeButton.current.click();
  //           setChangeState(null);

  //           client.off("message", messageListener);
  //           client._chartsListener = null;
  //         }
  //       };

  //       // clients[device.id].removeAllListeners("message");
  //       // clients[device.id].on("message", messageListener);
  //       client._chartsListener = messageListener;
  //       client.on("message", messageListener);

  //       let buffer = new ArrayBuffer(5);
  //       let asciiCode = new Uint8Array(buffer);
  //       asciiCode[0] = 17;
  //       asciiCode[1] = selectedChart + 1;
  //       asciiCode[2] = Number(chartInfo[0]);
  //       asciiCode[3] = chartInfo[1];
  //       asciiCode[4] = chartInfo[2];

  //       let message = device.internet_token;

  //       // ترکیب رشته و بافر
  //       let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
  //       clients[device.id].publish(device.serial + "/sys", combinedMessage);

  //       return () => {
  //         if (client._chartsListener) {
  //           client.off("message", client._chartsListener);
  //           client._chartsListener = null;
  //         }
  //       };
  //     }
  //   }
  // }, [chartsInfo]);

  const calculateCRC16Modbus = (buffer) => {
    let crc = 0xffff;

    for (let i = 0; i < buffer.length; i++) {
      crc ^= buffer[i];
      for (let j = 0; j < 8; j++) {
        if ((crc & 0x0001) !== 0) {
          crc = (crc >> 1) ^ 0xa001;
        } else {
          crc = crc >> 1;
        }
      }
    }

    const lowByte = crc & 0xff;
    const highByte = (crc >> 8) & 0xff;

    return [lowByte, highByte];
  };

  const concatenateStringAndBuffer = (str, buffer) => {
    let encoder = new TextEncoder();
    let encodedString = encoder.encode(str);

    let newBuffer = new Uint8Array(encodedString.length + buffer.byteLength);

    newBuffer.set(encodedString, 0);

    newBuffer.set(new Uint8Array(buffer), encodedString.length);

    return newBuffer;
  };

  const handleClickChart = (chartNumber) => {
    if (selectedChart != chartNumber) {
      if (chartsInfo[chartNumber][8] > 0 && chartsInfo[chartNumber][8] < 60) {
        setCycleNum(chartsInfo[chartNumber][8]);
      } else {
        setCycleNum(1);
      }
      setSelectedChart(chartNumber);
      // setStatus(!!chartsInfo[chartNumber][10]);
      // setSendOnChange(!!chartsInfo[chartNumber][9]);
    }
  };

  const handleSubmitState = () => {
    if (device) {
      if (device.is_bus && clients[device?.bridge_device?.id]) {
      } else if (
        device.id &&
        device.username &&
        device.password &&
        clients[device.id]
      ) {
        const messageListener = (topic, message) => {
          const endOfTwoCharToken =
            String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
          if (
            device.internet_token.slice(-2) === endOfTwoCharToken &&
            message[2] == 17
          ) {
            const charts = [];
            const chartSize = 11; // تعداد المان‌های هر نمودار
            const chartCount = (message.byteLength - 3) / chartSize;
            const data = message.slice(4);
            for (let i = 0; i < chartCount; i++) {
              const chartData = data.slice(i * chartSize, (i + 1) * chartSize);
              charts.push(chartData);
            }
            // setChartsInfo(charts);
            closeButton.current.click();
          }
        };

        // clients[device.id].removeAllListeners("message");
        clients[device.id].on("message", messageListener);

        let buffer = new ArrayBuffer(13);
        let asciiCode = new Uint8Array(buffer);
        asciiCode[0] = 17;
        asciiCode[1] = selectedChart + 1;
        asciiCode[2] = button.digit;
        asciiCode[3] = button.data1;
        asciiCode[4] = button.data2;
        asciiCode[5] = button.data3;
        asciiCode[6] = 0;
        asciiCode[7] = button.data4;
        let crc16 = calculateCRC16Modbus([
          asciiCode[2],
          asciiCode[3],
          asciiCode[4],
          asciiCode[5],
          asciiCode[5],
          asciiCode[7],
        ]);
        asciiCode[8] = crc16[0];
        asciiCode[9] = crc16[1];
        asciiCode[10] = chartsInfo[selectedChart][8];
        asciiCode[11] = chartsInfo[selectedChart][9];
        asciiCode[12] = chartsInfo[selectedChart][10];

        let message = device.internet_token;

        // ترکیب رشته و بافر
        let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
        clients[device.id].publish(device.serial + "/sys", combinedMessage);
      }
    }
  };

  const renderChartsInfo = () => {
    const elements = [];
    for (let i = 0; i < chartsInfo.length; i++) {
      let chartInfo = chartsInfo[i];
      let statusIndex;
      let cycleIndex;
      let sendOnChangeIndex;
      if (device.type == 16) {
        statusIndex = 10;
        cycleIndex = 8;
        sendOnChangeIndex = 9;
      } else {
        statusIndex = 2;
        cycleIndex = 0;
        sendOnChangeIndex = 1;
      }

      elements.push(
        <tr
          onClick={() => handleClickChart(i)}
          style={{
            boxShadow:
              selectedChart == i && hasSubmitKey
                ? "0 0.25rem 1rem rgba(0, 122, 255, 0.45)"
                : !hasSubmitKey && changeState == i
                  ? "0 0.25rem 1rem rgba(0, 122, 255, 0.45)"
                  : "none",
          }}
        >
          <td>
            <span>{i + 1}</span>
          </td>
          {hasStatus ? (
            <td>
              <div className="form-check mt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  checked={chartInfo[statusIndex] ? "checked" : ""}
                  onChange={() => {
                    // setStatus(!(!!chartInfo[statusIndex]));
                    setChartsInfo((prev) => {
                      const newCharts = [...prev];
                      newCharts[i][statusIndex] = +!prev[i][statusIndex];
                      return newCharts;
                    });
                    setChangeState(i);
                  }}
                  id="statusCheckbox"
                />
                <label
                  className="form-check-label"
                  for="statusCheckbox"
                ></label>
              </div>
            </td>
          ) : null}
          {hasSendOnChange ? (
            <td>
              <div className="form-check mt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  checked={chartInfo[sendOnChangeIndex] ? "checked" : ""}
                  onChange={() => {
                    // setSendOnChange(!(!!chartInfo[sendOnChangeIndex]));
                    setChartsInfo((prev) => {
                      const newCharts = [...prev];
                      newCharts[i][sendOnChangeIndex] =
                        +!prev[i][sendOnChangeIndex];
                      return newCharts;
                    });
                    setChangeState(i);
                  }}
                  id="sendOnChangeCheckbox"
                />
                <label
                  className="form-check-label"
                  for="sendOnChangeCheckbox"
                ></label>
              </div>
            </td>
          ) : null}
          {hasCycle ? (
            <td>
              <select
                className="form-select"
                value={chartInfo[cycleIndex]}
                onChange={(e) => {
                  // setCycleNum(e.target.value);
                  setChartsInfo((prev) => {
                    const newCharts = [...prev];
                    newCharts[i][cycleIndex] = e.target.value;
                    return newCharts;
                  });
                  setChangeState(i);
                }}
                style={{ width: "5rem" }}
              >
                {Array.from({ length: 60 }, (_, i) => (
                  <option value={i + 1}>{i + 1}</option>
                ))}
              </select>
            </td>
          ) : null}
          {hasQuantity ? (
            <td>
              <span className={selectedChart == i ? "text-danger" : ""}>
                {button && selectedChart == i
                  ? button.data4
                  : (chartInfo[4] << 8) | chartInfo[5]}
              </span>
            </td>
          ) : null}
          {hasDataAddress ? (
            <td>
              <span className={selectedChart == i ? "text-danger" : ""}>
                {button && selectedChart == i
                  ? (button.data2 << 8) | button.data3
                  : (chartInfo[2] << 8) | chartInfo[3]}
              </span>
            </td>
          ) : null}
          {hasFunctionCode ? (
            <td>
              <span className={selectedChart == i ? "text-danger" : ""}>
                {button && selectedChart == i ? button.data1 : chartInfo[1]}
              </span>
            </td>
          ) : null}
          {hasSlaveAddress ? (
            <td>
              <span className={selectedChart == i ? "text-danger" : ""}>
                {button && selectedChart == i ? button.digit : chartInfo[0]}
              </span>
            </td>
          ) : null}
        </tr>,
      );
    }
    return elements;
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="defineChartModal"
      tabIndex="-1"
      aria-labelledby="changeNameModal"
      aria-hidden="true"
      ref={modalName}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">تنظیم نمودار</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div className="table-responsive text-nowrap">
              <table className="table">
                <thead>
                  <tr>
                    <th>شماره نمودار</th>
                    {hasStatus ? <th>فعال</th> : null}
                    {hasSendOnChange ? (
                      <th>ارسال داده در صورت تغییر مقدار</th>
                    ) : null}
                    {hasCycle ? <th>سیکل داده (دقیقه)</th> : null}
                    {hasQuantity ? <th>تعداد</th> : null}
                    {hasDataAddress ? <th>آدرس داده</th> : null}
                    {hasFunctionCode ? <th>کد تابع</th> : null}
                    {hasSlaveAddress ? <th>آدرس اسلیو</th> : null}
                  </tr>
                </thead>
                <tbody className="table-border-bottom-0">
                  {renderChartsInfo()}
                </tbody>
              </table>
            </div>
          </div>
          {hasSubmitKey ? (
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success-app mb-2"
                onClick={handleSubmitState}
              >
                تایید
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default DefineChartModal;
